module.exports = __webpack_public_path__ + "static/media/vail-13.7ebb52da.jpg";